module.exports = __webpack_public_path__ + "static/media/diktat-1.5330550a.mp3";